import { StandardEvents } from '@shopify/events';

class FwProductInquiry extends HTMLElement {
  #eventTarget;

  connectedCallback() {
    this.#eventTarget = this.closest('.shopify-section');
    this.#eventTarget?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#eventTarget?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail) return;

        const { newProduct, productId, resource } = detail;
        if (newProduct) {
          this.dataset.fwProductId = newProduct.id;
          this.dataset.fwProductUrl = new URL(newProduct.url, window.location.origin).toString();
        } else if (productId && productId !== this.dataset.fwProductId) {
          return;
        }

        if (!resource) return;

        const productCode = this.dataset.fwProductCode || resource.sku || '';
        const variantTitle = this.dataset.fwHasRealVariant === 'true' ? resource.title || '' : '';
        this.#updateLink(productCode, variantTitle);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[fw-product-inquiry] Variant update failed:', error);
      });
  };

  /**
   * @param {string} productCode
   * @param {string} variantTitle
   */
  #updateLink(productCode, variantTitle) {
    const link = this.querySelector('[data-fw-inquiry-link]');
    const whatsappNumber = this.dataset.fwWhatsappNumber;
    if (!(link instanceof HTMLAnchorElement) || !whatsappNumber) return;

    let summary = `${this.dataset.fwIntro || 'Hola, quisiera consultar disponibilidad de:'} ${
      this.dataset.fwProductTitle || ''
    }.`;
    if (productCode) summary += ` Código: ${productCode}.`;

    const lines = [summary];

    if (variantTitle) lines.push(`Opción seleccionada: ${variantTitle}`);
    if (this.dataset.fwCompatibleModels) {
      lines.push(`Modelos compatibles: ${this.dataset.fwCompatibleModels}`);
    }

    lines.push(`Enlace: ${this.dataset.fwProductUrl || window.location.href}`);
    lines.push('', this.dataset.fwClosing || '');

    const whatsappUrl = new URL(`https://wa.me/${encodeURIComponent(whatsappNumber)}`);
    whatsappUrl.searchParams.set('text', lines.join('\n').trim());
    link.href = whatsappUrl.toString();
  }
}

if (!customElements.get('fw-product-inquiry')) {
  customElements.define('fw-product-inquiry', FwProductInquiry);
}
